import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import OrderService from '../services/Order'
import PurchaseService from '../services/Purchase'
import Loader from '../component/Loader'
import DefaultImage from '../assets/images/productDefault.png'
import ConfirmationModal from '../component/ConfirmationModal'
import ModalComponent from '../component/ModalComponent'
import AlertMsg from '../component/AlertMsg'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import Button from 'react-bootstrap/Button';
import OtherService from '../services/Other';
import ThemeTable from '../component/ThemeTable'
import useScrollToTop from '../hooks/useScrollToTop'
import toast from 'react-hot-toast'
import NoData from '../component/NoData'
import Skeleton from 'react-loading-skeleton'
import { useNavigate } from 'react-router-dom'
import ConsentModal from "../component/Modals/ConsentModal";
import { useSelector, useDispatch } from 'react-redux';

const MyOrders = () => {
    const navigate = useNavigate();
    useScrollToTop();
    
    // const concentList = useSelector((state) => state.currentUserSlice.myConcentList);
    const concentList = useSelector(
        (state) => state.currentUser.myConcentList
      );
      
    
    const [myOrderData, setMyOrderData] = useState([])
    const [myOrderNoData, setMyOrderNoData] = useState()
    const [hasData, sethasData] = useState(false)
    const [orderTrack, setOrderTrack] = useState([])
    const [loading, setLoading] = useState(true);
    const [isSelectedProduct, setIsSelectedProduct] = useState()
    const [isSelectedProductTrack, setIsSelectedProductTrack] = useState()
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
    const [isTrackModalOpen, setIsTrackModalOpen] = useState(false)
    const [isSelectedProductReviewOrderId, setIsSelectedProductReviewOrderId] = useState()
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false)
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertConfirm, setShowAlertConfirm] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false)
    const [visibleItemCount, setVisibleItemCount] = useState(12);
    const [confirmReceipt, setConfirmReceipt] = useState(null);
    const [productConditionSelect, setproductConditionSelect] = useState(null);
    const [overAllExperience, setoverAllExperience] = useState(undefined)
    const [isTextArea, setIsTextArea] = useState('')
    const [isReason, setIsReason] = useState({ id: "", title: "" })
    const [isReasonList, setIsReasonList] = useState([])
    const [complainImage, setComplainImage] = useState(null)
    const [complainImageTwo, setComplainImageTwo] = useState(null)
    const [experienceValidationError, setexperienceValidationError] = useState("");
    const [receiptValidationError, setReceiptValidationError] = useState("");
    const [productConditionValidationError, setProductConditionValidationError] = useState("");
    const [reasonValidationError, setReasonConditionValidationError] = useState("");
    const [productImgValidationError, setProductImgValidationError] = useState("");
    const [productImgTwoValidationError, setproductImgTwoValidationError] = useState("");
    const [showAlertFeedback, setShowAlertFeedback] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [openConcentModal, setOpenConcentModal] = useState(false);
    const [myOrderList, setMyOrderList] = useState([]);
    const [page, setPage] = useState("");
    const [myConcentList, setMyConcentList] = useState([]);
    

    const handleShowMore = () => {
        setVisibleItemCount(prevCount => prevCount + 12);
    };
 
    const handleCancelOrder = (item) => {

        setIsConfirmationModalOpen(true)
        setIsSelectedProduct(item)

    }
    function diff_hours(dt2, dt1) {
        // Calculate the difference in milliseconds between the two provided Date objects by subtracting the milliseconds value of dt1 from the milliseconds value of dt2
        let diff = (dt2.getTime() - dt1.getTime()) / 1000;
        // Convert the difference from milliseconds to hours by dividing it by the number of seconds in an hour (3600)
        diff /= (60 * 60);
        // Return the absolute value of the rounded difference in hours
        return Math.abs(Math.round(diff));
    }

    function isCancellable(orderCreatedAt) {
        const createdDate = new Date(orderCreatedAt);
        const nowDate = new Date();
        return (diff_hours(nowDate, createdDate) <= 48)
    }
    // const OrderDataFetch = async () => {
    //     try {
    //         const token = localStorage.getItem('access_token');
    //         const OrderDataFetchResponse = await OrderService.myOrderList()

    //         if (JSON.stringify(OrderDataFetchResponse) != '{}') {
    //             const filteredData = OrderDataFetchResponse.data.map((item, index) => {
    //                 // const orderDate = formatDate(item.item_status_created_at)
    //                 const orderDate = new Date(item.item_status_created_at);
    //                 const formattedOrderDate =   orderDate.getDate() +
    //                 ' ' +
    //                 getMonthName(orderDate.getMonth() + 1) +
    //                 ' ' +
    //                 orderDate.getFullYear() +
    //                 ', ' +
    //                 orderDate.toLocaleTimeString('en-US', {
    //                   hour: 'numeric',
    //                   minute: 'numeric',
    //                   hour12: true,
    //                   // timeZone: 'Asia/Calcutta',
    //                   timeZone: 'UTC',
    //                 })
    //                 let serialNo = <div className="text-center">{index + 1}</div>
    //                 const placeHolderImage =
    //                     <div className="itemWrapImageMyOrder">
    //                         <img src={DefaultImage} alt='image' />
    //                     </div>
    //                 const productName = <div className="text-left productNameBlock">{item.product_name}</div>
    //                 const orderStatus = <p className='orderTxt text-left'>

    //                     {
    //                         (item.item_status === "Cancelled") ? <span className='redDot'></span> :
    //                             (item.item_status === "Dispatched") ? <span className='orangeDot'></span> :
    //                                 (item.item_status === "Delivered") ? <span className='greenDot'></span> :
    //                                     <span className='yellowDot'></span>
    //                     }
    //                     {
    //                         (item.item_status === "Cancelled") ? 'Cancelled' :
    //                             (item.item_status === "Dispatched") ? 'Dispatched' :
    //                                 (item.item_status === "Delivered") ? 'Delivered' :
    //                                     <>Ordered On <span className="orderDate">{formattedOrderDate}</span></>
    //                     }
    //                 </p>
    //                 const actionButtons = <div className='ordersButtonWrap'>
    //                     {(item.item_status != "Cancelled") && (
    //                         <>
    //                             <div className='trackOrderTxt' onClick={() => { handleTrackOrder(item.item_id) }}>
    //                                 <PrimaryGradientButton buttonText="Track Order" />
    //                             </div>
    //                             <div className='feedbackTrackOrderTxt' onClick={() => handleReviewOrder(item.order_id)}>
    //                                 <PrimaryOutLineButton outlinebuttonText="Feedback" />
    //                             </div>
    //                             {/* {item.item_status != 'Cancelled' &&
    //                                 <div className='cancelTrackOrderTxt'>
    //                                     <Button disabled={!isCancellable(item.order_created_at)} variant="danger"  onClick={() => { handleCancelOrder(item) }}>Cancel Order</Button>
    //                                 </div>
    //                             } */}
    //                             {item.item_status !== 'Cancelled' && isCancellable(item.order_created_at) && (
    //                                 <div className='cancelTrackOrderTxt'>
    //                                     <Button 
    //                                         variant="danger"  
    //                                         onClick={() => handleCancelOrder(item)}
    //                                     >
    //                                         Cancel Order
    //                                     </Button>
    //                                 </div>
    //                             )}

    //                              {item.show_button && (
    //                                 <div className="feedbackTrackOrderTxt">
    //                                     <PrimaryOutLineButton
    //                                         onClick={() => {
    //                                             if (item?.order_item_consent_status == null) {
    //                                                 setPage("addconsent");
    //                                             } else {
    //                                                 setPage("myconsent");
    //                                             }
    //                                             setOpenConcentModal(true);
    //                                         }}
    //                                         outlinebuttonText={
    //                                             item?.order_item_consent_status == null
    //                                             ? "Add Consent"
    //                                             : "My Consent"
    //                                         }
    //                                     />
    //                                 </div>
    //                             )}
    //                         </>

    //                     )}
    //                     {(item.item_status == "Cancelled") && (
    //                         <>
    //                             <div className='trackOrderTxt'>
    //                                 <PrimaryGradientButton onClick={() => { handleTrackOrder(item.item_id) }} buttonText="Track Order" />
    //                             </div>
    //                             <div className='feedbackTrackOrderTxt' >
    //                                 <PrimaryOutLineButton onClick={() => handleReviewOrder(item.order_id)} disabled={item.item_status == "Cancelled"} outlinebuttonText="Feedback" />
    //                             </div>

    //                         </>
    //                     )}
    //                 </div>
    //                 return {

    //                     'Order Id': <div className="text-center">{item.order_id}</div>,
    //                     'Product Image': placeHolderImage,
    //                     'Product Name': productName,
    //                     'Quantity': item.item_quantity,
    //                     'Order Status': orderStatus,
    //                     'Actions': actionButtons,

    //                 }
    //             })
    //             setMyOrderData(filteredData)
    //             sethasData(true)
    //             setLoading(false)
    //         }
    //         else {
    //             setMyOrderNoData('No Orders are listed')
    //             setLoading(false)
    //             sethasData(false)

    //         }
    //     }
    //     catch (error) {
    //         console.error('OrderDataFetch')
    //         setLoading(false)
    //         sethasData(false)
    //         setMyOrderNoData('No Orders are listed')

    //     }
    // }
    const OrderDataFetch = async () => {
    try {
        const token = localStorage.getItem('access_token');

        const OrderDataFetchResponse = await OrderService.myOrderList();

        if (JSON.stringify(OrderDataFetchResponse) !== '{}') {

            const filteredData = OrderDataFetchResponse.data.map((item, index) => {

                const orderDate = new Date(item.item_status_created_at);

                const formattedOrderDate =
                    orderDate.getDate() +
                    ' ' +
                    getMonthName(orderDate.getMonth() + 1) +
                    ' ' +
                    orderDate.getFullYear() +
                    ', ' +
                    orderDate.toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                        // timeZone: 'Asia/Calcutta',
                        timeZone: 'UTC',
                    });

                const serialNo = (
                    <div className="text-center">
                        {index + 1}
                    </div>
                );

                const placeHolderImage = (
                    <div className="itemWrapImageMyOrder">
                        <img src={DefaultImage} alt="image" />
                    </div>
                );

                const productName = (
                    <div className="text-left productNameBlock">
                        {item.product_name}
                    </div>
                );

                const orderStatus = (
    <p className="orderTxt text-left">
        {
            item.item_status === "Cancelled" ? (
                <span className="redDot"></span>
            ) : item.item_status === "Dispatched" ? (
                <span className="orangeDot"></span>
            ) : item.item_status === "Delivered" ||
              item.item_status === "Accepted" ? (
                <span className="greenDot"></span>
            ) : (
                <span className="yellowDot"></span>
            )
        }

        {
            item.item_status === "Open" ? (
                <>
                    Ordered On{" "}
                    <span className="orderDate">
                        {formattedOrderDate}
                    </span>
                </>
            ) : (
                // item.order_status || item.item_status
                item.item_status
            )
        }
    </p>
);

                // Action buttons
                const actionButtons = (
                    <div className="ordersButtonWrap">

                        {/* Non-cancelled orders */}
                        {item.item_status !== "Cancelled" && (
                            <>
                                {/* Track Order */}
                                <div
                                    className="trackOrderTxt"
                                    onClick={() => {
                                        handleTrackOrder(item.item_id);
                                    }}
                                >
                                    <PrimaryGradientButton
                                        buttonText="Track Order"
                                    />
                                </div>

                                {/* Feedback */}
                                <div
                                    className="feedbackTrackOrderTxt"
                                    onClick={() =>
                                        handleReviewOrder(item.order_id)
                                    }
                                >
                                    <PrimaryOutLineButton
                                        outlinebuttonText="Feedback"
                                    />
                                </div>

                                {/* Cancel Order */}
                                {item.item_status !== "Cancelled" &&
                                    isCancellable(item.order_created_at) && (
                                        <div className="cancelTrackOrderTxt">
                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    handleCancelOrder(item)
                                                }
                                            >
                                                Cancel Order
                                            </Button>
                                        </div>
                                    )}

                                {/* Consent */}
                                {item.show_button && (
                                    <div className="feedbackTrackOrderTxt">
                                        <PrimaryOutLineButton
                                            onClick={() => {
                                                if (
                                                    item?.order_item_consent_status ==
                                                    null
                                                ) {
                                                    setPage("addconsent");
                                                } else {
                                                    setPage("myconsent");
                                                }

                                                setOpenConcentModal(true);
                                            }}
                                            outlinebuttonText={
                                                item?.order_item_consent_status ==
                                                null
                                                    ? "Add Consent"
                                                    : "My Consent"
                                            }
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        {/* Cancelled orders */}
                        {item.item_status === "Cancelled" && (
                            <>
                                {/* Track Order */}
                                <div className="trackOrderTxt">
                                    <PrimaryGradientButton
                                        onClick={() => {
                                            handleTrackOrder(item.item_id);
                                        }}
                                        buttonText="Track Order"
                                    />
                                </div>

                                {/* Feedback */}
                                <div className="feedbackTrackOrderTxt">
                                    <PrimaryOutLineButton
                                        onClick={() =>
                                            handleReviewOrder(item.order_id)
                                        }
                                        disabled={
                                            item.item_status === "Cancelled"
                                        }
                                        outlinebuttonText="Feedback"
                                    />
                                </div>
                            </>
                        )}

                    </div>
                );

                return {
                    'Order Id': (
                        <div className="text-center">
                            {item.order_id}
                        </div>
                    ),

                    'Product Image': placeHolderImage,

                    'Product Name': productName,

                    'Quantity': item.item_quantity,

                    'Order Status': orderStatus,

                    'Actions': actionButtons,
                };
            });

            setMyOrderData(filteredData);
            sethasData(true);
            setLoading(false);

        } else {

            setMyOrderNoData('No Orders are listed');
            setLoading(false);
            sethasData(false);
        }

    } catch (error) {

        console.error('OrderDataFetch', error);

        setLoading(false);
        sethasData(false);
        setMyOrderNoData('No Orders are listed');
    }
};
    useEffect(() => {

        OrderDataFetch()
    }, [])
    function getMonthName(month) {
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return months[month - 1]; // Adjusting for zero-based index
    }
    function formatDate(date) {
        const d = new Date(date);
        // return (d.getDate() + " " + getMonthName(d.getMonth() + 1) + " " + d.getFullYear()+", "+d.getHours()+":"+d.getMinutes())
        return (
            d.getDate() +
            ' ' +
            getMonthName(d.getMonth() + 1) +
            ' ' +
            d.getFullYear() +
            ', ' +
            d.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            })
        );
    }

    //Cancel Order
    const handleOptionSelection = async (response) => {

        if (cancelLoading) {
            return
        }

        if (response == 'Yes') {
            setCancelLoading(true)

            try {
                // const token = localStorage.getItem('access_token');
                const userInfo = JSON.parse(localStorage.getItem('userData'));
                const hierId = userInfo.dcm_hierarchies_id
                const payload = {
                    order_id: parseInt(isSelectedProduct.order_id),
                    item_id: parseInt(isSelectedProduct.item_id),
                    status: 'Cancelled',
                    contractor_hierarchy_id: parseInt(hierId),
                    recredit_points_for: ['Cancelled'],
                }
                const res = await OrderService.cancelOrder(payload)

                if (res.response_code == 200) {
                   
                    setIsConfirmationModalOpen(true)
                    if (res.data.status) {
                        toast.success(res.data.message)
                      
                        OrderDataFetch()

                      } else {
                        toast.error(res.data.message)
                      }
                    // setShowAlertConfirm(true)
                    // setIsLoginSuccess({ isLogin: true, text: res.data.message })
                    // setTimeout(() => {
                    //     setShowAlertConfirm(false)
                        setIsConfirmationModalOpen(false)
                        setCancelLoading(false)

                    // }, 2000)

                }
                else {
                    setShowAlertConfirm(true)
                    setIsLoginSuccess({ isLogin: false, text: res.data.message })
                    setTimeout(() => {
                        setShowAlertConfirm(false)
                        setIsConfirmationModalOpen(false)
                        setCancelLoading(false)

                    }, 2000)

                }
            }
            catch (error) {
                console.error("Order Cancel")
                setCancelLoading(false)
            }

        }
        if (response == 'No') {
            setIsConfirmationModalOpen(false)

        }

    }
    //Track Order
    const handleTrackOrder = (item) => {
        setIsTrackModalOpen(true)
        setIsSelectedProductTrack(item)
    }
    useEffect(() => {
        if (isSelectedProductTrack) {
            const TrackOrder = async () => {
                try {
                    const orderId = isSelectedProductTrack;
                    const token = localStorage.getItem('access_token');
                    const TrackOrderResponse = await OrderService.trackOrder(orderId, token);

                    if (TrackOrderResponse.response_code == 200) {
                        console.log("data----------------->", TrackOrderResponse.data.order_track);
                        
                        setOrderTrack(TrackOrderResponse.data.order_track)

                    }
                } catch (error) {
                    console.error('Track Order');
                }
            };
            TrackOrder();
        }
    }, [isSelectedProductTrack]);
    //Review order

    useEffect(() => {
        const ReasonDataFetch = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const ReasonResponse = await OtherService.reasonListReview(token)
                if (ReasonResponse.response_code == 200 && ReasonResponse.data.reasonDetails.length > 0) {
                    setIsReasonList(ReasonResponse.data.reasonDetails?.map((item, index) => ({
                        id: item.id,
                        title: item.description
                    })));
                }
            }
            catch (error) {
                console.error('ReasonDataFetch')
            }

        }
        ReasonDataFetch()
    }, [])

    const resetFeedbackModalState = () => {
        setConfirmReceipt(null);
        setproductConditionSelect(null);
        setoverAllExperience(undefined);
        setIsTextArea('');
        setIsReason({ id: "", title: "" });
        setComplainImage(null);
        setComplainImageTwo(null);
        setexperienceValidationError("");
        setReceiptValidationError("");
        setProductConditionValidationError("");
        setReasonConditionValidationError("");
        setProductImgValidationError("");
        setproductImgTwoValidationError("");
        setShowAlertFeedback(false);
    };

    useEffect(() => {
        if (!isReviewModalOpen) {
            resetFeedbackModalState();
        }
    }, [isReviewModalOpen]);
    
    const handleReasonChange = (selectedValue) => {
        setIsReason(selectedValue)
        setReasonConditionValidationError('')

    }
    const handleReviewOrder = (itemID) => {
        setIsReviewModalOpen(true)
        setIsSelectedProductReviewOrderId(itemID)

    }
    const handleReviewOptionSelection = (response) => {

        if (response == 'Yes' || response == 'No') {
            setConfirmReceipt(response)
            setReceiptValidationError('')
        }
        if (response == 'Good' || response == 'Bad') {
            setproductConditionSelect(response)
            setProductConditionValidationError('')
            if (response === 'Bad') {
                // If response is 'Bad', additional validations are required
                // setReasonConditionValidationError("Reason is required.");
                // setProductImgValidationError("Product Image is required.");
                // setproductImgTwoValidationError("Product Image is required.");
            }
        }
        if (response == 0 || response == 1 || response == 2 || response == 3 || response == 4) {
            setoverAllExperience(response)
            setexperienceValidationError('')
        }

    }
    const handleOnRevieSubmit = async () => {
        let isValid = true;
        if (overAllExperience == undefined) {
            setexperienceValidationError("Overall experience is required.")
            isValid = false;
        }
        const validations = [
            {
                value: confirmReceipt,
                setter: setReceiptValidationError,
                message: "Confirm receipt of order is required.",
                checkFor: 'restOption'
            },
            {
                value: productConditionSelect,
                setter: setProductConditionValidationError,
                message: "Product condition is required.",
                checkFor: 'restOption'
            },
            {
                value: isReason.title,
                setter: setReasonConditionValidationError,
                message: "Reason is required.",
                checkFor: 'Bad'
            },
            {
                value: complainImage,
                setter: setProductImgValidationError,
                message: "Product Image is required.",
                checkFor: 'Bad'
            },
            {
                value: complainImageTwo,
                setter: setproductImgTwoValidationError,
                message: "Product Image is required.",
                checkFor: 'Bad'
            }
        ];

        // Perform validations
        validations.forEach(({ value, setter, message, checkFor }) => {
            if(confirmReceipt === 'No')
                return;
            if ((productConditionSelect == 'Bad' && checkFor == 'Bad' && !value) || (productConditionSelect != 'Bad' && checkFor != 'Bad' && !value)) {
                setter(message);
                isValid = false;
            } else {
                setter(""); // Clear the error message
            }
        });

        if (isValid) {
            setIsButtonLoading(true)
            try {

                const formData = new FormData();
                formData.append("order_id", String(isSelectedProductReviewOrderId));
                formData.append("overall_website_rating", overAllExperience);
                formData.append("delivery_confirmation", confirmReceipt);
                formData.append("product_condition", productConditionSelect);
                formData.append("product_condition_description", isReason.title);
                formData.append("overall_suggestion", isTextArea);
                if(complainImage)
                    formData.append("file_1", complainImage.file);
                if(complainImageTwo)
                    formData.append("file_2", complainImageTwo.file);

                // const token = localStorage.getItem('access_token');
                const res = await OtherService.reviewCreate(formData)
                if (res.response_code && res.data.status == true) {
                    setIsButtonLoading(false)
                    toast.success('Thank You for your feedback')
                    // setShowAlertFeedback(true)
                    // setIsLoginSuccess({ isLogin: true, text:  })
                    setTimeout(() => {
                        setIsReviewModalOpen(false)
                    }, 2000)
                }
                else {
                    setIsButtonLoading(false)
                    // setShowAlertFeedback(true)
                    toast.error('Thank You for your feedback')
                    // setIsLoginSuccess({ isLogin: false, text: res.data.message })
                    setIsReviewModalOpen(true)
                }
            }
            catch (error) {
                console.error('Form Data Response')
            }
        }

    }

    // function cancelOrder(itemId, orderId) {

    //     const payload = {
    //       order_id: parseInt(orderId),
    //       item_id: parseInt(itemId),
    //       status: 'Cancelled',
    //       contractor_hierarchy_id: parseInt(localStorage.getItem()),
    //       recredit_points_for: ['Cancelled'],
    //     };

    //     setCancelLoading(true);
    //     OrderService.cancelOrder(payload)
    //     .then(res => {

    //         if (!res.error) {
    //         setCancelLoading(false);
    //         if (res.data.status) {
    //             setTimeout(() => {
    //             OrderDataFetch()
    //             }, 3000);
    //         } else {
    //             setTimeout(() => {
    //             // resetFields()
    //             // loadOrders()
    //             }, 3000);
    //         }
    //         } else {
    //         setCancelLoading(false);
           
    //         }
    //     })
    //     .catch(err => {
    //         setCancelLoading(false);

    //     });
    //   }

    const handleTextReview = (e) => {
        setIsTextArea(e.target.value)

    }
    const setComplainImageHandler = (product) => {
        setComplainImage(product)
        setProductImgValidationError('')

    }
    const setComplainImageTwoHandler = (productTwo) => {
        setComplainImageTwo(productTwo)
        setproductImgTwoValidationError('')

    }

    // const handleShowProduct = (catgryId) => {
    //     navigate(`/rewards-category-list/${catgryId}`)
    // }

    function loadOrders() {
        setLoading(true);
            PurchaseService.myConcentList().then(res => {
            if (res.statusCode == 401) {
            //   logoutHandler(navigation);
            }
            if (JSON.stringify(res) != '{}' && !res.error) {
              setLoading(false);
              setMyOrderList(res.data);
            } else {
              setLoading(false);
            }
          });
      }

    async function onReceiveConcent(selectedConcent) {
        if(selectedConcent.id != 44) {
            navigate(`/raise-ticket`, {
                state: {
                  catId: selectedConcent.categoryId,
                  catName: "Order Related",
                  subCatId: selectedConcent.subCategoryId,
                  subCatName: "Damaged or Defective product Received",
                  selectedOrder: myOrderData,
                },
              })
        } else {
            try {
                const payload = {
                    "dcm_orders_id":myOrderData.order_id,
                    "dcm_orders_item_id": myOrderData.item_id,
                    "consent": selectedConcent.id
                }
                const res = await OtherService.receivedConcent(payload);
                if(res.data.status) {
                    loadOrders(false);
                    setOpenConcentModal(false);
                    toast.success(res.data.message);
                }
            } catch(err) {
            }
        }
    }

    return (
        <>
            {/* {loading && <Loader />} */}
            <BreadCrumbSecttion pageTitle="My Redemption" currentPageName="My Redemption" />
            <section className='padTop50'>
                <Container>
            {!loading && myOrderData.length === 0 && <NoData />}
                    <Row>
                        <Col xs={12} lg={4} className='my-4'>

                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                heading={isLoginSuccess.heading}
                                text={isLoginSuccess.text}
                            />
                            }

                        </Col>
                    </Row>
                    {myOrderData.length === 0 && loading && <Skeleton height={50} />}
                    {myOrderData.length > 0 && <Row>
                        <Col xs={12}>
                            <ThemeTable showLodeMoreBtn={false} data={myOrderData} />
                        </Col>
                    </Row>}
                    {/* {myOrderData.length === 0 && !loading && <Row>
                        <Col xs={12}>
                            <NoData />
                        </Col>
                    </Row>} */}
                    <Row>
                        <Col xs={12} lg={4}>
                            <ConfirmationModal
                                page="myOrders"
                                setIsModalOpen={setIsConfirmationModalOpen}
                                isModalOpen={isConfirmationModalOpen}
                                modalTitle="Please Confirm"
                                modalDescription="Are you sure? Do you want to cancel this order?"
                                onReviewSubmit={handleOptionSelection}
                                selectOptions={isReasonList}
                                setSelectedValue={setIsReason}
                                selectedValue={isReason}
                                onChange={handleReasonChange}
                                showAlert={showAlertConfirm}
                                isButtonLoading={cancelLoading}
                                isLoginSuccessHeading={isLoginSuccess.heading}
                                isLoginSuccessText={isLoginSuccess.text}
                                isLoginSuccessCondition={isLoginSuccess.isLogin}
                            />

                        </Col>

                    </Row>

                    <Row>
                        <Col xs={12} lg={4}>
                            <ModalComponent
                                page='trackOrder'
                                setIsModalOpen={setIsTrackModalOpen}
                                isModalOpen={isTrackModalOpen}
                                modalTitle="Track Your Order"
                                trackOrderData={orderTrack}

                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={4}>
                            <ModalComponent
                                page='reviewOrder'
                                setIsModalOpen={setIsReviewModalOpen}
                                selectedStar={overAllExperience}
                                value={overAllExperience}
                                isModalOpen={isReviewModalOpen}
                                modalTitle="Feedback Info"
                                onClickOptionSelection={handleReviewOptionSelection}
                                onReviewSubmit={handleOnRevieSubmit}
                                onTextReviewChange={handleTextReview}
                                isTextAreaVal={isTextArea}
                                isSelectedStar={overAllExperience}
                                setIsTextAreaVal={setIsTextArea}
                                selectOptions={isReasonList}
                                setSelectedValue={setIsReason}
                                selectedValue={isReason}
                                handleReasonChangeOnChange={handleReasonChange}
                                complainImage={complainImage}
                                setcomplainImage={setComplainImageHandler}
                                setcomplainImageTwo={setComplainImageTwoHandler}
                                complainImageTwo={complainImageTwo}
                                experienceValidationError={experienceValidationError}
                                receiptValidationError={receiptValidationError}
                                productConditionValidationError={productConditionValidationError}
                                reasonValidationError={reasonValidationError}
                                productImgValidationError={productImgValidationError}
                                productImgTwoValidationError={productImgTwoValidationError}
                                showAlert={showAlertFeedback}
                                isLoginSuccessHeading={isLoginSuccess.heading}
                                isLoginSuccessText={isLoginSuccess.text}
                                productConditionSelect={productConditionSelect}
                                isLoginSuccessCondition={isLoginSuccess.isLogin}
                                isButtonLoading={isButtonLoading}

                            />

                        </Col>

                    </Row>

                    <ConsentModal
                        page={page}
                        setIsModalOpen={setOpenConcentModal}
                        isModalOpen={openConcentModal}
                        modalTitle="Please provide your consent"
                        modalDescription="Hello World"
                        onConsentSubmit={(selected) => {
                            setOpenConcentModal(false);
                        }}
                        consentOptions={concentList}
                    />
                        
                </Container>
            </section >
        </>
    )
}

export default MyOrders